export default function MenuDivider() {
  return <div className="bg-sbeige h-px w-[8px]"></div>;
}
